import { render, staticRenderFns } from "./config.vue?vue&type=template&id=de8201aa&scoped=true"
import script from "./config.vue?vue&type=script&lang=ts"
export * from "./config.vue?vue&type=script&lang=ts"
import style0 from "./config.vue?vue&type=style&index=0&id=de8201aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8201aa",
  null
  
)

export default component.exports